import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20artistic%20Korean%20manhwa%20illustration%20collage%2C%20dramatic%20comic%20style%20hero%20image%2C%20vibrant%20warm%20coral%20and%20golden%20amber%20tones%2C%20abstract%20comic%20panel%20composition%2C%20dynamic%20brush%20strokes%2C%20action%20and%20romance%20elements%20blend%2C%20cinematic%20lighting%2C%20artistic%20high%20contrast%2C%20epic%20scale%2C%20professional%20illustration%20quality&width=1800&height=900&seq=home-hero-bg&orientation=landscape"
        alt="韩漫大全 - 韩国漫画在线阅读平台"
        title="韩漫大全 - 好看看的韩国漫画在线免费阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/60"></div>

      <div className="relative z-10 w-full text-center px-6 md:px-10">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 text-sm font-medium text-background-50 border border-background-50/30 rounded-full backdrop-blur-sm mb-6">
            {t('home.hero.badge')}
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-background-50 leading-tight tracking-tight mb-6">
            {t('home.hero.title')}
            <br />
            <span className="text-accent-400">{t('home.hero.titleHighlight')}</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/75 max-w-xl mx-auto mb-8 font-light">
            {t('home.hero.subtitle')}
          </p>

          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/category/all"
              className="whitespace-nowrap px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
            >
              {t('home.hero.cta')}
            </Link>
            <Link
              to="/category/all"
              className="whitespace-nowrap px-7 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full text-sm font-medium hover:bg-background-50/25 transition-colors cursor-pointer border border-background-50/20"
            >
              {t('home.hero.browse')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}